module.exports = __webpack_public_path__ + "img/as.2d15e6e8.svg";